// import external modules
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
class Pagination extends Component {
  render() {
    //console.log(this.props);
    return (
      <div className="pagination-main-block">
        <div className="pagination-inner-block">
          <div className="status-data-block">
            {this.props.showTag && (
              <ul className="status-block">
                <li className="status-wrapper">
                  <p className="dot-wrapper active">Active</p>
                </li>
                <li className="status-wrapper">
                  <p className="dot-wrapper non-active">Non Active</p>
                </li>
                <li className="status-wrapper">
                  <p className="dot-wrapper freezed">Freezed</p>
                </li>
              </ul>
            )}
            {this.props.showLeadTag && (
              <ul className="status-block">
                <li className="status-wrapper">
                  <p className="dot-wrapper new">New</p>
                </li>
                <li className="status-wrapper">
                  <p className="dot-wrapper contacted">Contacted</p>
                </li>
                <li className="status-wrapper">
                  <p className="dot-wrapper freezed">In-progress</p>
                </li>
                <li className="status-wrapper">
                  <p className="dot-wrapper converted">Converted</p>
                </li>
                <li className="status-wrapper">
                  <p className="dot-wrapper lost">Lost</p>
                </li>
              </ul>
            )}
          </div>
          <div className="pagination-wrapper">
            <div className="row-par-page">
              <ul>
                <li className="row-par-element">
                  <p className="row-par-page-title d-inline-flex">
                    Row Per Page :
                  </p>
                </li>
                <li className="row-par-element">
                  <div className="row-select">
                    <div className="form-group mb-0 d-block">
                      <select
                        className="form-control"
                        id="rowparpage"
                        onChange={(e) => {
                          this.props.getData(e.target.value, this.props.page);
                        }}
                      >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                      </select>
                    </div>
                  </div>
                </li>
                <li className="row-par-element">
                  <p className="data-range">
                    <span className="">
                      {(this.props.page - 1) * this.props.limit}-
                      {this.props.totalCount >
                      this.props.page * this.props.limit
                        ? this.props.page * this.props.limit
                        : this.props.totalCount}
                    </span>{" "}
                    of
                    <span> {this.props.totalCount}</span>
                  </p>
                </li>
                <li className="row-par-element">
                  <ul className="chevron-block">
                    <li className="chevron-list-element">
                      <span
                        onClick={() => {
                          if (this.props.page > 1)
                            this.props.getData(
                              this.props.limit,
                              this.props.page - 1,
                            );
                        }}
                      >
                        <svg
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g
                            id="Admin-account"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                            opacity="1"
                          >
                            <g
                              id="Gym"
                              transform="translate(-1241.000000, -841.000000)"
                            >
                              <g
                                id="DataTable/TableFooter"
                                transform="translate(323.000000, 824.000000)"
                              >
                                <g
                                  id="keyboard_arrow_left-24px"
                                  transform="translate(930.000000, 29.000000) rotate(-180.000000) translate(-930.000000, -29.000000) translate(918.000000, 17.000000)"
                                >
                                  <rect
                                    id="Rectangle"
                                    x="0"
                                    y="0"
                                    width="24"
                                    height="24"
                                  ></rect>
                                  <g
                                    id="keyboard_arrow_right-24px"
                                    className="arrow"
                                    transform="translate(8.000000, 6.000000)"
                                    fill="#000000"
                                    fill-rule="nonzero"
                                  >
                                    <path
                                      d="M1.29,9.88 L5.17,6 L1.29,2.12 C0.9,1.73 0.9,1.1 1.29,0.71 C1.68,0.32 2.31,0.32 2.7,0.71 L7.29,5.3 C7.68,5.69 7.68,6.32 7.29,6.71 L2.7,11.3 C2.31,11.69 1.68,11.69 1.29,11.3 C0.91,10.91 0.9,10.27 1.29,9.88 Z"
                                      id="Path"
                                    ></path>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </span>
                    </li>
                    <li className="chevron-list-element">
                      <span
                        onClick={() => {
                          if (
                            this.props.totalCount >
                            this.props.limit * this.props.page
                          ) {
                            this.props.getData(
                              this.props.limit,
                              this.props.page + 1,
                            );
                          }
                        }}
                      >
                        <svg
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g
                            id="Admin-account"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <g
                              id="Gym"
                              transform="translate(-1277.000000, -841.000000)"
                            >
                              <g
                                id="DataTable/TableFooter"
                                transform="translate(323.000000, 824.000000)"
                              >
                                <g
                                  id="keyboard_arrow_right-24px"
                                  transform="translate(954.000000, 17.000000)"
                                >
                                  <rect
                                    id="Rectangle"
                                    x="0"
                                    y="0"
                                    width="24"
                                    height="24"
                                  ></rect>
                                  <g
                                    transform="translate(8.000000, 6.000000)"
                                    className="arrow"
                                    fill="#000000"
                                    fill-rule="nonzero"
                                    id="Path"
                                  >
                                    <path d="M1.29,9.88 L5.17,6 L1.29,2.12 C0.9,1.73 0.9,1.1 1.29,0.71 C1.68,0.32 2.31,0.32 2.7,0.71 L7.29,5.3 C7.68,5.69 7.68,6.32 7.29,6.71 L2.7,11.3 C2.31,11.69 1.68,11.69 1.29,11.3 C0.91,10.91 0.9,10.27 1.29,9.88 Z"></path>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </span>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Pagination.defaultProps = {
  showTag: true,
};

const mapStateToProps = (state) => {
  const {} = state.login;
  return {};
};
export default connect(mapStateToProps, {})(Pagination);
